module.exports = __webpack_public_path__ + "static/media/esposeguros.d27a926d.png";